import { Link } from "react-router-dom";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect, useRef } from "react";
import config from "../../Common/Configurations/APIConfig";
import { handleError, handleSuccess } from "../../Common/Layout/CustomAlerts";
import axios from "axios";
import Lead from "../Public/Lead";
const initialFieldValues = {
    landingPageId: "00000000-0000-0000-0000-000000000000",
    phoneNumber: "",
    email: "",
    heroSectionTitle_1: "",
    heroSectionTitle_2: "",
    heroSectionTitle_3: "",
    heroSectionParagraph: "",
    aboutus_Title: "",
    aboutus_List: "",
    about_Image: "",
    broker_Title: "",
    broker_List: "",
    broker_Image: "",
    funder_Title: "",
    funder_List: "",
    funder_Image: "",
    comingSoon_Text: "",
    signUp_Text: "",
    footer_Address: "",
    footer_CopyRights: "",
    topHeader_Color: "",
    heroSection_Color: "",
    footer_Color: "",
    footer_Facebook: "",
    footer_Instagram: "",
    footer_LinkedIn: "",
    footer_Twitter: "",
    aboutImageFile: null,
    funderImageFile: null,
    brokerImageFile: null,
    aboutImageSrc: "",
    funderImageSrc: "",
    brokerImageSrc: ""
};
export default function LandingPage() {
    const [values, setValues] = useState(initialFieldValues);
    const [aboutListItems, setAboutListItems] = useState([]);
    const [aboutItem, setAboutItem] = useState("");
    const [funderListItems, setFunderListItems] = useState([]);
    const [funderItem, setFunderItem] = useState("");
    const [brokerListItems, setBrokerListItems] = useState([]);
    const [brokerItem, setBrokerItem] = useState("");
    const [btnSubmit, setBtnSubmit] = useState(false);
    const topColorInputRef = useRef(null);
    const heroColorInputRef = useRef(null);
    const footerColorInputRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [homeShow, setHomeShow] = useState(false);
    const [aboutShow, setAboutShow] = useState(false);
    const [funderShow, setFunderShow] = useState(false);
    const [lenderShow, setLenderShow] = useState(false);
    const [footerShow, setFooterShow] = useState(false);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "multipart/form-data"
        }
    }
    const showAboutPreview = e => {
        if (e.target.files && e.target.files[0]) {
            let aboutImageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = x => {
                setValues({
                    ...values,
                    aboutImageFile,
                    aboutImageSrc: x.target.result
                })
            }
            reader.readAsDataURL(aboutImageFile)
        }
        else {
            setValues({
                ...values,
                aboutImageFile: null,
                aboutImageSrc: ""
            })
        }
    }
    const showBrokerPreview = e => {
        if (e.target.files && e.target.files[0]) {
            let brokerImageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = x => {
                setValues({
                    ...values,
                    brokerImageFile,
                    brokerImageSrc: x.target.result
                })
            }
            reader.readAsDataURL(brokerImageFile)
        }
        else {
            setValues({
                ...values,
                brokerImageFile: null,
                brokerImageSrc: ""
            })
        }
    }
    const showFunderPreview = e => {
        if (e.target.files && e.target.files[0]) {
            let funderImageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = x => {
                setValues({
                    ...values,
                    funderImageFile,
                    funderImageSrc: x.target.result
                })
            }
            reader.readAsDataURL(funderImageFile)
        }
        else {
            setValues({
                ...values,
                funderImageFile: null,
                funderImageSrc: ""
            })
        }
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
        if (topColorInputRef.current) {
            topColorInputRef.current.blur();
        }
        if (heroColorInputRef.current) {
            heroColorInputRef.current.blur();
        }
        if (footerColorInputRef.current) {
            footerColorInputRef.current.blur();
        }
    };
    const handleHomeClose = () => {
        setHomeShow(false);
    };
    const handleHomeShow = () => {
        setHomeShow(true);
    };
    const handleFunderClose = () => {
        setFunderShow(false);
    };
    const handleFunderShow = () => {
        setFunderShow(true);
    };
    const handleLenderClose = () => {
        setLenderShow(false);
    };
    const handleLenderShow = () => {
        setLenderShow(true);
    };
    const handleAboutClose = () => {
        setAboutShow(false);
    };
    const handleAboutShow = () => {
        setAboutShow(true);
    };
    const handleFooterClose = () => {
        setFooterShow(false);
    };
    const handleFooterShow = () => {
        setFooterShow(true);
    };
    const handleAddAboutItem = () => {
        if (aboutItem.trim()) {
            setAboutListItems([...aboutListItems, aboutItem]);
            setAboutItem("");
        }
    };
    const handleDeleteAboutItem = (index) => {
        const updatedItems = [...aboutListItems];
        updatedItems.splice(index, 1);
        setAboutListItems(updatedItems);
    };
    const handleAddFunderItem = () => {
        if (funderItem.trim()) {
            setFunderListItems([...funderListItems, funderItem]);
            setFunderItem("");
        }
    };
    const handleDeleteFunderItem = (index) => {
        const updatedItems = [...funderListItems];
        updatedItems.splice(index, 1);
        setFunderListItems(updatedItems);
    };
    const handleAddLenderItem = () => {
        if (brokerItem.trim()) {
            setBrokerListItems([...brokerListItems, brokerItem]);
            setBrokerItem("");
        }
    };
    const handleDeleteLenderItem = (index) => {
        const updatedItems = [...brokerListItems];
        updatedItems.splice(index, 1);
        setBrokerListItems(updatedItems);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(true);
            const aboutItems = aboutListItems.join('*');
            const brokerItems = brokerListItems.join('*');
            const funderItems = funderListItems.join('*');
            var formData = new FormData();
            formData.append("landingPageId", values.landingPageId)
            formData.append("phoneNumber", values.phoneNumber)
            formData.append("email", values.email)
            formData.append("heroSectionTitle_1", values.heroSectionTitle_1)
            formData.append("heroSectionTitle_2", values.heroSectionTitle_2)
            formData.append("heroSectionTitle_3", values.heroSectionTitle_3)
            formData.append("heroSectionParagraph", values.heroSectionParagraph)
            formData.append("aboutus_Title", values.aboutus_Title)
            formData.append("aboutus_List", aboutItems)
            formData.append("broker_Title", values.broker_Title)
            formData.append("broker_List", brokerItems)
            formData.append("funder_Title", values.funder_Title)
            formData.append("funder_List", funderItems)
            formData.append("footer_Address", values.footer_Address)
            formData.append("footer_Color", values.footer_Color)
            formData.append("footer_CopyRights", values.footer_CopyRights)
            formData.append("footer_Facebook", values.footer_Facebook)
            formData.append("footer_Instagram", values.footer_Instagram)
            formData.append("footer_LinkedIn", values.footer_LinkedIn)
            formData.append("footer_Twitter", values.footer_Twitter)
            formData.append("signUp_Text", values.signUp_Text)
            formData.append("topHeader_Color", values.topHeader_Color)
            formData.append("heroSection_Color", values.heroSection_Color)
            formData.append("aboutImageFile", values.aboutImageFile)
            formData.append("funderImageFile", values.funderImageFile)
            formData.append("brokerImageFile", values.brokerImageFile)
            axios.put(config.APIACTIVATEURL + config.LANDINGPAGEUPDATE, formData, { ...headerconfig })
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Updated");
                        GetData();
                        setBtnSubmit(false);
                        handleAboutClose(true);
                        handleFooterClose(true);
                        handleHomeClose(true);
                        handleFunderClose(true);
                        handleLenderClose(true);
                    }
                    else {
                        handleError(res.data.message);
                        setBtnSubmit(false);
                    }
                })
                .catch(function (error) {
                    handleError("Error in updating data");
                    setBtnSubmit(false);
                });
        }
    };
    const validate = () => {
        let temp = {};
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    const GetData = () => {
        axios.get(config.APIACTIVATEURL + config.LANDINGPAGEGET, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    if (response.data.data !== null) {
                        setValues(response.data.data);
                        if (response.data.data != null) {
                            if (response.data.data.aboutus_List != null) {
                                setAboutListItems(response.data.data.aboutus_List.split('*').filter(Boolean))
                            }
                            if (response.data.data.funder_List != null) {
                                setFunderListItems(response.data.data.funder_List.split('*').filter(Boolean))
                            }
                            if (response.data.data.broker_List != null) {
                                setBrokerListItems(response.data.data.broker_List.split('*').filter(Boolean))
                            }
                        }
                    }
                }
            });
    };
    useEffect(() => {
        GetData();
    }, [])
    return (
        <div className="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="landing" style={{ paddingTop: "120px" }}>
                <div className="topbar-image py-8 rounded-0 mb-0 alert fade show" style={{ backgroundColor: values.topHeader_Color }}>
                    <div className="d-flex justify-content-end gap-sm-3 gap-2 align-items-right text-right flex-md-nowrap flex-wrap">
                        <span className="mb-0 text-white fw-bold px-2"><i className="fas fa-phone me-2" style={{color:"#d60000"}}></i>{values.phoneNumber}</span>
                        <p className="mb-0 text-white fw-bold"><i className="fas fa-envelope me-2" style={{color:"#d60000"}}></i>{values.email}</p>
                    </div>
                </div>
                <div className="row justify-content-end">
                    <div className="col-1">
                        <button onClick={handleHomeShow} className="btn btn-sm btn-primary position-absolute end-0 m-3" style={{ zIndex: 10 }} title="Edit"><i className="fas fa-edit"></i> Edit</button>
                    </div>
                </div>
                <div className="nft-hero" style={{ backgroundColor: values.heroSection_Color }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="text-center">
                                    <h3 className="outfitslider mb-4 lh-base text-black">{values.heroSectionTitle_1}<br />
                                        <span className="text-black">{values.heroSectionTitle_2}</span></h3>
                                </div>
                                <div className="text-center">
                                    <h3 className="outfit mb-4 lh-base" style={{ color: "#000000" }}>{values.heroSectionTitle_3}</h3>
                                    <p className="fs-4 mb-4" style={{ color: "#000000" }}>
                                        {values.heroSectionParagraph}
                                    </p>
                                </div>
                            </div>{/*end col*/}
                        </div>{/* end row */}
                    </div>
                </div>
            </div>
            <section className="pt-3 body-wrapper" style={{marginTop:"0px", paddingTop:"0px", backgroundColor:"#f1f2f3"}}>
                <div className="container-fluid">
                    <div className="row justify-content-end">
                        <div className="col-1">
                            <button onClick={handleAboutShow} className="btn btn-sm btn-primary position-absolute end-0 m-3" style={{ zIndex: 10 }} title="Edit"><i className="fas fa-edit"></i> Edit</button>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-4">
                            <div class="bg-primary-subtle rounded-0 p-1">
                                <img src={values.aboutImageSrc} alt="icon" class="w-100 h-100"></img>
                            </div>
                        </div>
                        <div className="col-8">
                            <h2 className="fw-bolder mb-4">{values.aboutus_Title}</h2>
                            <div className="row">
                                <div className="col-12 mb-lg-5">
                                    {aboutListItems.map((item, idx) => (
                                        <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                            <div className="d-flex align-items-center">
                                                <iconify-icon className="text-success me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                                {item}
                                            </div>
                                        </li>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-primary py-3 ">
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-center flex-md-nowrap flex-wrap gap-3">
                        <p className="mb-0 text-white fs-4">Launching soon!</p>
                        <Link to="/register" className="text-white fs-4 fw-semibold text-underline">Join the Beta Group</Link>
                    </div>
                </div>
            </section>
            <div className="p-3 text-center">
                <h3>A Better Way to Work for Brokers and Funders</h3>
            </div>
            <section className="pt-3">
                <div className="container-fluid">
                    <div className="row justify-content-end">
                        <div className="col-1">
                            <button onClick={handleLenderShow} className="btn btn-sm btn-primary position-absolute end-0 m-3" style={{ zIndex: 10 }} title="Edit"><i className="fas fa-edit"></i> Edit</button>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-6">
                            <h2 className="fw-bolder mb-4">{values.broker_Title}</h2>
                            <div className="row">
                                <div className="col-12 mb-lg-5">
                                    <ul class="list-group outfit" style={{ border: "0" }}>
                                        {brokerListItems.map((item, idx) => (
                                            <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                                <div className="d-flex align-items-center">
                                                    <iconify-icon className="text-success me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                                    {item}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="bg-primary-subtle rounded-0 p-1">
                                <img src={values.brokerImageSrc} alt="icon" className="w-100"></img>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="pt-3">
                <div className="container-fluid">
                    <div className="row justify-content-end">
                        <div className="col-1">
                            <button onClick={handleFunderShow} className="btn btn-sm btn-primary position-absolute end-0 m-3" style={{ zIndex: 10 }} title="Edit"><i className="fas fa-edit"></i> Edit</button>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-6">
                            <h2 className="fw-bolder mb-4">{values.funder_Title}</h2>
                            <div className="row">
                                <div className="col-12 mb-lg-5">
                                    <ul class="list-group outfit" style={{ border: "0" }}>
                                        {funderListItems.map((item, idx) => (
                                            <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                                <div className="d-flex align-items-center">
                                                    <iconify-icon className="text-success me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                                    {item}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="bg-primary-subtle rounded-0 p-1">
                                <img src={values.funderImageSrc} alt="icon" className="w-100"></img>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer className="custom-footer py-5 position-relative" style={{ backgroundColor: values.footer_Color }}>
                <div className="row justify-content-end">
                    <div className="col-1">
                        <button onClick={handleFooterShow} className="btn btn-sm btn-primary position-absolute end-0 m-3" style={{ zIndex: 10 }} title="Edit"><i className="fas fa-edit"></i> Edit</button>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 mt-4"><div>
                            <div>
                                <img alt="logo light" height={80} width={280} src="/assets/images/logo3d.png" />
                            </div>
                            <div className="mt-4 text-black">
                                <p>{values.footer_CopyRights}</p>
                            </div>
                        </div>
                        </div>
                        <div className="col-lg-7 ms-lg-auto">
                            <div className="row">
                                <div className="col-sm-4 mt-4" />
                                <div className="col-sm-3 mt-4" />
                                <div className="col-sm-5 mt-4">
                                    <h5 className="text-black mb-0">Contact</h5>
                                    <div className="text-black mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list fs-3">
                                            <li className="p-1">{values.footer_Address}</li>
                                            <li className="p-1">Email : {values.email}</li>
                                            <li className="p-1">Phone : {values.phoneNumber}</li>
                                        </ul>
                                    </div>
                                    <div className="text-sm-end mt-3 mt-sm-0">
                                                <ul className="list-inline mb-0 footer-social-link">
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Facebook} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-facebook-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Twitter} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-twitter-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_LinkedIn} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-linkedin-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Instagram} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-instagram-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <Modal show={homeShow} onHide={handleHomeClose} size="lg">
                <Modal.Header>
                    <Modal.Title>Hero Section - Landing Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <div className="row">
                            <div className="col-lg-4 mb-3">
                                <label htmlFor="title" className="form-label">Top Header Background Color</label>
                                <input type="color" ref={topColorInputRef} style={{ minHeight: "50px" }} value={values.topHeader_Color} name="topHeader_Color" onChange={handleInputChange} className={"form-control" + applyErrorClass('topHeader_Color')} placeholder="" />
                            </div>
                            <div className="col-lg-4 mb-3">
                                <label htmlFor="title" ref={heroColorInputRef} className="form-label">Hero Section Background Color</label>
                                <input type="color" style={{ minHeight: "50px" }} value={values.heroSection_Color} name="heroSection_Color" onChange={handleInputChange} className={"form-control" + applyErrorClass('heroSection_Color')} placeholder="" />
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="title" className="form-label">Heading 1</label>
                                <input type="text" value={values.heroSectionTitle_1} name="heroSectionTitle_1" onChange={handleInputChange} className={"form-control" + applyErrorClass('heroSectionTitle_1')} placeholder="" />
                                {errors.heroSectionTitle_1 === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Heading 2</label>
                                <input type="text" value={values.heroSectionTitle_2} name="heroSectionTitle_2" onChange={handleInputChange} className={"form-control" + applyErrorClass('heroSectionTitle_2')} placeholder="" />
                                {errors.heroSectionTitle_2 === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Title</label>
                                <input type="text" value={values.heroSectionTitle_3} name="heroSectionTitle_3" onChange={handleInputChange} className={"form-control" + applyErrorClass('title')} placeholder="" />
                                {errors.heroSectionTitle_3 === false ? (<div className="validationerror">Please enter Title </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Paragraph</label>
                                <input type="text" value={values.heroSectionParagraph} name="heroSectionParagraph" onChange={handleInputChange} className={"form-control" + applyErrorClass('heroSectionParagraph')} placeholder="" />
                                {errors.heroSectionParagraph === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="col-6 mb-3">
                                <label htmlFor="title" className="form-label">Email</label>
                                <input type="text" value={values.email} name="email" onChange={handleInputChange} className={"form-control" + applyErrorClass('email')} placeholder="Email" />
                                {errors.email === false ? (<div className="validationerror">Please enter email </div>) : ('')}
                            </div>
                            <div className="col-6 mb-3">
                                <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                                <input type="text" value={values.phoneNumber} name="phoneNumber" onChange={handleInputChange} className={"form-control" + applyErrorClass('phoneNumber')} placeholder="Phone Number" />
                                {errors.phoneNumber === false ? (<div className="validationerror">Please enter phoneNumber </div>) : ('')}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        btnSubmit === false ?
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>Please wait...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleHomeClose}>Close</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={aboutShow} onHide={handleAboutClose} size="lg">
                <Modal.Header>
                    <Modal.Title>Landing Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <div className="row">
                            <div className="col-6 mb-3">
                                <label htmlFor="title" className="form-label">Image</label>
                                <div className="picture-container">
                                    <div className="picture mb-3">
                                        <img src={values.aboutImageSrc} className="picture-src" width="250px" height="250px" controls />
                                    </div>
                                    <input id="image-uploader" name="aboutImageSrc" className={"form-control-file" + applyErrorClass('aboutImageSrc')} type="file" onChange={showAboutPreview} />
                                </div>
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="title" className="form-label">Heading</label>
                                <input type="text" value={values.aboutus_Title} name="aboutus_Title" onChange={handleInputChange} className={"form-control" + applyErrorClass('aboutus_Title')} placeholder="" />
                                {errors.aboutus_Title === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="mt-3 d-flex justify-content-between align-items-center p-3">
                                <input type="text" value={aboutItem} className="form-control" onChange={e => setAboutItem(e.target.value)} placeholder="Enter new list" />
                                <button onClick={handleAddAboutItem} className="btn btn-sm btn-primary me-2">Add</button>
                            </div>
                            <div>
                                {aboutListItems.map((item, idx) => (
                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                        <div className="d-flex align-items-center">
                                            <iconify-icon className="text-success me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                            {item}
                                        </div>
                                        <button type="button" onClick={() => handleDeleteAboutItem(idx)} className="btn btn-sm btn-danger">Delete</button>
                                    </li>
                                ))}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        btnSubmit === false ?
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>Please wait...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleAboutClose}>Close</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={lenderShow} onHide={handleLenderClose} size="lg">
                <Modal.Header>
                    <Modal.Title>Brokers - Landing Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <div className="row">
                            <div className="col-6 mb-3">
                                <label htmlFor="title" className="form-label">Image</label>
                                <div className="picture-container">
                                    <div className="picture mb-3">
                                        <img src={values.brokerImageSrc} className="picture-src" width="250px" height="250px" controls />
                                    </div>
                                    <input id="image-uploader" name="brokerImageSrc" className={"form-control-file" + applyErrorClass('brokerImageSrc')} type="file" onChange={showBrokerPreview} />
                                </div>
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="title" className="form-label">Heading</label>
                                <input type="text" value={values.broker_Title} name="broker_Title" onChange={handleInputChange} className={"form-control" + applyErrorClass('broker_Title')} placeholder="" />
                                {errors.broker_Title === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="mt-3 d-flex justify-content-between align-items-center p-3">
                                <input type="text" value={brokerItem} className="form-control" onChange={e => setBrokerItem(e.target.value)} placeholder="Enter new list" />
                                <button type="button" onClick={handleAddLenderItem} className="btn btn-sm btn-primary me-2">Add</button>
                            </div>
                            <div>
                                {brokerListItems.map((item, idx) => (
                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                        <div className="d-flex align-items-center">
                                            <iconify-icon className="text-success me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                            {item}
                                        </div>
                                        <button type="button" onClick={() => handleDeleteLenderItem(idx)} className="btn btn-sm btn-danger">Delete</button>
                                    </li>
                                ))}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        btnSubmit === false ?
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>Please wait...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleLenderClose}>Close</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={funderShow} onHide={handleFunderClose} size="lg">
                <Modal.Header>
                    <Modal.Title>Funders - Landing Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <div className="row">
                            <div className="col-6 mb-3">
                                <label htmlFor="title" className="form-label">Image</label>
                                <div className="picture-container">
                                    <div className="picture mb-3">
                                        <img src={values.funderImageSrc} className="picture-src" width="250px" height="250px" controls />
                                    </div>
                                    <input id="image-uploader" name="funderImageSrc" className={"form-control-file" + applyErrorClass('funderImageSrc')} type="file" onChange={showFunderPreview} />
                                </div>
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="title" className="form-label">Heading</label>
                                <input type="text" value={values.funder_Title} name="funder_Title" onChange={handleInputChange} className={"form-control" + applyErrorClass('aboutus_Title')} placeholder="" />
                                {errors.aboutus_Title === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="mt-3 d-flex justify-content-between align-items-center p-3">
                                <input type="text" value={funderItem} className="form-control" onChange={e => setFunderItem(e.target.value)} placeholder="Enter new list" />
                                <button onClick={handleAddFunderItem} className="btn btn-sm btn-primary me-2">Add</button>
                            </div>
                            <div>
                                {funderListItems.map((item, idx) => (
                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                        <div className="d-flex align-items-center">
                                            <iconify-icon className="text-success me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                            {item}
                                        </div>
                                        <button type="button" onClick={() => handleDeleteFunderItem(idx)} className="btn btn-sm btn-danger">Delete</button>
                                    </li>
                                ))}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        btnSubmit === false ?
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>Please wait...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleFunderClose}>Close</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={footerShow} onHide={handleFooterClose} size="lg">
                <Modal.Header>
                    <Modal.Title>Footer Section - Landing Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <div className="row">
                            <div className="col-lg-4 mb-3">
                                <label htmlFor="title" ref={footerColorInputRef} className="form-label">Background Color</label>
                                <input type="color" style={{ minHeight: "50px" }} value={values.footer_Color} name="footer_Color" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_Address')} placeholder="" />
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="title" className="form-label">Address</label>
                                <input type="text" value={values.footer_Address} name="footer_Address" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_Address')} placeholder="" />
                                {errors.footer_Address === false ? (<div className="validationerror">Please enter Address </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Copy Rights</label>
                                <input type="text" value={values.footer_CopyRights} name="footer_CopyRights" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_CopyRights')} placeholder="" />
                                {errors.footer_CopyRights === false ? (<div className="validationerror">Please enter Heading </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Facebook</label>
                                <input type="text" value={values.footer_Facebook} name="footer_Facebook" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_Facebook')} placeholder="" />
                                {errors.footer_Facebook === false ? (<div className="validationerror">Please enter link </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Twitter</label>
                                <input type="text" value={values.footer_Twitter} name="footer_Twitter" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_Twitter')} placeholder="" />
                                {errors.footer_Twitter === false ? (<div className="validationerror">Please enter link </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">LinkedIn</label>
                                <input type="text" value={values.footer_LinkedIn} name="footer_LinkedIn" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_LinkedIn')} placeholder="" />
                                {errors.footer_LinkedIn === false ? (<div className="validationerror">Please enter link </div>) : ('')}
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="title" className="form-label">Instagram</label>
                                <input type="text" value={values.footer_Instagram} name="footer_Instagram" onChange={handleInputChange} className={"form-control" + applyErrorClass('footer_Instagram')} placeholder="" />
                                {errors.footer_Instagram === false ? (<div className="validationerror">Please enter link </div>) : ('')}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        btnSubmit === false ?
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>Please wait...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleFooterClose}>Close</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div >
    );
}
